import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { DomainCacheService } from './domain-cache.service';

const baseRef = 'area-atuacao';
const route = {
  buscar:  `${baseRef}/combo`
}

@Injectable({
  providedIn: 'root'
})
export class AreaAtuacaoService {

  constructor(
    private apiService: ApiService,
    private domainCache: DomainCacheService
  ) { }

  listarAreaAtuacaoCombo() {
    return this.domainCache.getOrLoad(route.buscar, () =>
      this.apiService.get<any>(route.buscar, undefined, undefined, true)
    );
  }
}
